module.exports = __webpack_public_path__ + "img/Frame_dashboard.0947d02b.jpg";